let TP_SERVER_DOMAIN, AGGR_DOMAIN, EXPLORER_TRANSIT_DOMAIN, TRANSIT_DOMAIN;

if (process.env.VUE_APP_ENV === 'production') {
    TP_SERVER_DOMAIN = 'https://preserver.mytokenpocket.vip';
    AGGR_DOMAIN = 'https://aggserver.mytokenpocket.vip'
    EXPLORER_TRANSIT_DOMAIN = 'https://explorer.transit.finance/#/hash/'
    TRANSIT_DOMAIN = 'https://swap.transit.finance/'
}
else if (process.env.VUE_APP_ENV === 'beta') {
    TP_SERVER_DOMAIN = 'https://preserver.mytokenpocket.vip';
    AGGR_DOMAIN = 'https://agtest.mytokenpocket.vip'
    EXPLORER_TRANSIT_DOMAIN = 'https://test-tp.tokenpocket.pro/swap-explorer/#/hash/'
    TRANSIT_DOMAIN = 'https://swap.transit.finance/'
  }
  else if (process.env.VUE_APP_ENV === 'dev') {
    TP_SERVER_DOMAIN = 'https://testserver.mytokenpocket.vip';
    AGGR_DOMAIN = 'https://agtest.mytokenpocket.vip'
    EXPLORER_TRANSIT_DOMAIN = 'https://test-tp.tokenpocket.pro/swap-explorer/#/hash/'
    TRANSIT_DOMAIN = 'https://test-tp.tokenpocket.pro/'
}

export { TP_SERVER_DOMAIN, AGGR_DOMAIN, EXPLORER_TRANSIT_DOMAIN, TRANSIT_DOMAIN }